import React from "react";
import { Coffee, Utensils } from "lucide-react";

const FavouriteBar = ({ items = [], onSelect }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="w-full overflow-x-auto scrollbar-hide scrollbar-thin">
      <div className="flex gap-4 px-4 py-6 min-w-max">
        {items.map((item) => (
          <div
            key={item._id}
            onClick={() => onSelect(item)}
            className="
              w-[170px] min-h-[240px]
              bg-darkbg rounded-xl
              shadow-md
              hover:shadow-xl
              transition-all duration-300
              cursor-pointer
              flex flex-col
              overflow-hidden
            "
          >
            {/* IMAGE */}
            <div className="h-[140px] w-full bg-gray-100 overflow-hidden flex items-center justify-center">
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition duration-300"
                />
              ) : (
                <div className="flex flex-col items-center justify-center text-gray-400">
                  {item.categoryName?.toLowerCase().includes("drink") ? (
                    <Coffee className="w-10 h-10" />
                  ) : (
                    <Coffee className="w-10 h-10" />
                  )}
                </div>
              )}
            </div>

            {/* CONTENT */}
            <div className="p-4 flex flex-col justify-between flex-1">
              <p className="text-sm font-semibold text-gray-800 uppercase tracking-wide">
                {item.title}
              </p>

              <p className="text-sm text-gray-500 mt-2">
                from ${item.price.toFixed(2)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavouriteBar;
